export const DAY = 'DAY';
export const HOUR = 'HOUR';
export const QUARTER_HOUR = 'QUARTER_HOUR';
export const FIXED = 'FIXED';

export const BILLING_RATE = [
    {
        data: DAY,
        view: 'Per Day'
    },
    {
        data: HOUR,
        view: 'Per Hour'
    },
    {
        data: QUARTER_HOUR,
        view: 'Per 15 Minutes'
    },
    {
        data: FIXED,
        view: 'Fixed Rate'
    }
];

export const SESSION_BILLING_RATE = [
    {
        data: DAY,
        view: 'Per Day'
    },
    {
        data: HOUR,
        view: 'Per Hour'
    },
    {
        data: QUARTER_HOUR,
        view: 'Per 15 Minutes'
    },
    {
        data: FIXED,
        view: 'Fixed Rate'
    }
];

export const DROP_IN_BILLING_RATE = [
    {
        data: DAY,
        view: 'Per Day'
    },
    {
        data: HOUR,
        view: 'Per Hour'
    }
];


// WEBPACK FOOTER //
// ./src/constants/billing-rate.js